export default __webpack_public_path__ + "static/media/kashi-neon.490e8e0f.png";